import React, {useEffect, useState} from 'react';
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";
import http from "../services/http";

const NewsletterPanel = () => {
    const [rows, setRows] = useState([]);   // [{year:number, visible:boolean}]
    const [loading, setLoading] = useState(true);

    const token = localStorage.getItem("token"); // falls du Bearer-Auth nutzt

    useEffect(() => {
        (async () => {
            try {
                const res = await http.get(`/api/admin/newsletter/years`);
                setRows(res.data || []);
            } catch (e) {
                // Fallback: aktuelles & nächstes Jahr, unsichtbar
                const y = new Date().getFullYear();
                setRows([{ year: y, visible: false }, { year: y + 1, visible: false }]);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const toggleVisibility = async (year, currentVisible) => {
        // Optimistic UI
        setRows(prev =>
            prev.map(r => (r.year === year ? { ...r, visible: !currentVisible } : r))
        );
        try {
            await http.put(`/api/admin/newsletter/years/${year}/visibility`, { visible: !currentVisible });
        } catch (e) {
            // Rollback bei Fehler
            setRows(prev =>
                prev.map(r => (r.year === year ? { ...r, visible: currentVisible } : r))
            );
            alert("Konnte Sichtbarkeit nicht speichern.");
        }
    };

    return (
        <div className="bg-gray-200 pt-24">
            <Navbar />
            <h1 className="text-3xl font-bold w-1/2 m-auto mb-6 mt-5">Newsletter Übersicht</h1>
            <a
                className="absolute cursor-pointer right-32 top-28 bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2"
                href="/admin"
            >
                Zurück
            </a>

            <table className="table-auto w-1/2 m-auto border">
                <thead>
                <tr className="bg-gray-300">
                    <th className="p-3 border text-left">Jahr</th>
                    <th className="p-3 border">Sichtbar (Public)</th>
                    <th className="p-3 border">Aktionen</th>
                </tr>
                </thead>
                <tbody>
                {loading ? (
                    Array.from({ length: 4 }).map((_, i) => (
                        <tr key={i} className="animate-pulse">
                            <td className="p-3 border">
                                <div className="h-4 bg-gray-300 rounded w-24" />
                            </td>
                            <td className="p-3 border text-center">
                                <div className="h-8 bg-gray-300 rounded w-24 mx-auto" />
                            </td>
                            <td className="p-3 border text-center">
                                <div className="h-8 bg-gray-300 rounded w-24 mx-auto" />
                            </td>
                        </tr>
                    ))
                ) : (
                    rows.map(({ year, visible }) => (
                        <tr key={year} className="text-center">
                            <td className="p-3 border text-left">{year}</td>
                            <td className="p-3 border">
                                <button
                                    onClick={() => toggleVisibility(year, visible)}
                                    className={`px-4 py-1 rounded font-semibold transition
                               ${visible
                                        ? "bg-green-600 text-white hover:ring-2"
                                        : "bg-gray-400 text-white hover:ring-2"}`}
                                    title={visible ? "In öffentlicher Liste sichtbar" : "In öffentlicher Liste ausgeblendet"}
                                >
                                    {visible ? "Öffentlich" : "Ausgeblendet"}
                                </button>
                            </td>
                            <td className="p-3 border">
                                <a
                                    className="bg-blue-500 text-white px-4 py-1 rounded hover:ring-2"
                                    href={`/admin/newsletter/${year}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Öffnen
                                </a>
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </table>

            <div className="w-full m-60"></div>
            <Footer />
        </div>
    );
};

export default NewsletterPanel;
